import {
  ConnectionListResult,
  getMaxDownstreamDatasources,
  getMaxDownstreamWorkbooks,
  GridSortProps,
  MaxCountsResultData,
  PaginatedQueryWrapper,
  SelectionProviderChildProps,
} from '@tableau/data-catalog-shared';
import * as React from 'react';

import {
  VirtualConnectionTableColumnsByIdQuery,
  VirtualConnectionTableColumnsByIdQuery_virtualConnectionTables_columnsConnection_nodes,
  VirtualConnectionTableColumnsByIdQueryVariables,
} from '../../../gen-src/queries/VirtualConnectionTableColumnsByIdQuery';
import { ColumnSortOrder } from '../../../gen-src/queries/globalTypes';
import {
  VirtualConnectionTableColumnsByIdQueryGql,
} from '../../queries/VirtualConnectionTableColumnsByIdQueryGql';
import { ColumnsValidSortFields } from '../sorting/sortProviders/ColumnsGridSortProvider';
import { VirtualConnectionTableColumnsDisplayGrid, VirtualConnectionTableColumnsGridRowData } from './VirtualConnectionTableColumnsDisplayGrid';

export type QueryVariables = VirtualConnectionTableColumnsByIdQueryVariables;
export type QueryResults = VirtualConnectionTableColumnsByIdQuery;
export type QueryResultListNode = VirtualConnectionTableColumnsByIdQuery_virtualConnectionTables_columnsConnection_nodes;
export type GridRowData = VirtualConnectionTableColumnsGridRowData;

export type VirtualConnectionTableColumnsQueryGridProps =
  SelectionProviderChildProps &
  GridSortProps<ColumnsValidSortFields> & {
    readonly vizportalUrlId: string;
    readonly rowCount: number | null;
  };

function selectConnectionListResult(resultData: QueryResults): ConnectionListResult<QueryResultListNode> | null {
  return resultData && resultData.virtualConnectionTables && resultData.virtualConnectionTables[0] &&
    resultData.virtualConnectionTables[0].columnsConnection;
}

function selectMaxCountsResult(resultData: QueryResults): MaxCountsResultData {
  return resultData && resultData.virtualConnectionTables && resultData.virtualConnectionTables[0];
}

function mapResultNode(
  node: QueryResultListNode,
  resultData: QueryResults,
): GridRowData {
  const virtualConnectionTables = selectMaxCountsResult(resultData);
  return {
    ...node,
    virtualConnectionTableId: resultData.virtualConnectionTables[0].vizportalUrlId,
    maxDownstreamDatasources: getMaxDownstreamDatasources(virtualConnectionTables),
    maxDownstreamWorkbooks: getMaxDownstreamWorkbooks(virtualConnectionTables),
  };
}

export function VirtualConnectionTableColumnsQueryGrid(props: VirtualConnectionTableColumnsQueryGridProps): JSX.Element {
  return (
    <PaginatedQueryWrapper<QueryVariables, QueryResults, QueryResultListNode, GridRowData>
      queryGql={VirtualConnectionTableColumnsByIdQueryGql}
      partialQueryVariables={{
        vizportalUrlId: props.vizportalUrlId,
        orderBy: props.orderBy as unknown as ColumnSortOrder,
      }}
      selectConnectionListResult={selectConnectionListResult}
      mapResultNode={mapResultNode}
    >
      {({ rowStore }) => (
        <VirtualConnectionTableColumnsDisplayGrid
          rowStore={rowStore}
          selectedKeys={props.selectedKeys}
          updateSelectionForKey={props.updateSelectionForKey}
          rowCount={props.rowCount}
          orderBy={props.orderBy}
          updateSortOrder={props.updateSortOrder}
        />
      )}
    </PaginatedQueryWrapper>
  );
}

